import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Newsletter } from './pages/Newsletter';
import { GetStarted } from './pages/GetStarted';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { AccessibilityStatement } from './pages/AccessibilityStatement';
import { ProfessionalRegistration } from './pages/ProfessionalRegistration';
import { useRoute } from './lib/navigation';
export function App() {
  const route = useRoute();
  useEffect(() => {
    document.title = 'Arrive Psychotherapy | Online Therapy for Young Adults';
  }, []);
  const renderPage = () => {
    switch (route) {
      case '#/':
      case '':
        return <Home data-id="element-0" />;
      case '#/about':
        return <About data-id="element-1" />;
      case '#/services':
        return <Services data-id="element-2" />;
      case '#/newsletter':
        return <Newsletter data-id="element-3" />;
      case '#/get-started':
        return <GetStarted data-id="element-4" />;
      case '#/privacy-policy':
        return <PrivacyPolicy data-id="element-5" />;
      case '#/terms-of-service':
        return <TermsOfService data-id="element-6" />;
      case '#/accessibility':
        return <AccessibilityStatement data-id="element-7" />;
      case '#/professional-registration':
        return <ProfessionalRegistration data-id="element-8" />;
      default:
        return <Home data-id="element-9" />;
    }
  };
  return <div className="min-h-screen bg-white selection:bg-terracotta/30 selection:text-teal flex flex-col" data-id="element-10">
      <Navbar data-id="element-11" />
      <main className="flex-grow" data-id="element-12">{renderPage()}</main>
      <Footer data-id="element-13" />
    </div>;
}